import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

import { OnboardingService } from '../shared/services/onboarding.service';

@Component({
  selector: 'app-onboarding-step-one',
  templateUrl: './onboarding-step-one.component.html',
  styleUrl: './onboarding-step-one.component.scss',
  standalone: false,
})
export class OnboardingStepOneComponent {
  @Output() nextStep = new EventEmitter<any>(false);

  constructor(
    private onboardingService: OnboardingService,
    private router: Router
  ) {}

  submit() {
    this.nextStep.emit({ moveToNextStep: true, updateUser: false });
  }

  skipOnboarding() {
    this.onboardingService.setOnboardingForUser().subscribe({
      next: (res: any) => {
        if (res && res.status) {
          this.router.navigateByUrl('/');
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
